import { DatePivotParams } from "../../entities/date_pivot_params";
import dayjs from "../../utils/dayjs";

export const defaultConfig: DatePivotParams = {
  dateHierarchy: "purchase_order_month",
  measure: "quantity",
  segments: ["supplier"],
  minDate: dayjs.utc().startOf("month").toDate(),
  maxDate: dayjs.utc().add(12, "month").startOf("month").toDate(),
  filters: [],
};
